import { render, staticRenderFns } from "./Generic_ReleaseModal.vue?vue&type=template&id=6ec43640&"
import script from "./Generic_ReleaseModal.vue?vue&type=script&lang=js&"
export * from "./Generic_ReleaseModal.vue?vue&type=script&lang=js&"
import style0 from "./Generic_ReleaseModal.vue?vue&type=style&index=0&id=6ec43640&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports